module.exports = __webpack_public_path__ + "img/mascot-1-large.766ad237.png";